import React, { useState, useRef, useEffect } from "react";
import { emailValidation } from "../../../functions/validation";

const EmailInput = (props) => {
  const {
    emailList,
    setEmailList,
    setMarginTop,
    containerHeight,
    setContainerHeight,
    getUserCount,
    invitationCount,
    checkIndividualEmail,
  } = props;
  const [currentEmail, setCurrentEmail] = useState("");
  const emailBlocksContainerRef = useRef(null);
  const emailBlocksRef = useRef(null);

  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === ",") {
      event.preventDefault();
      const newEmail = currentEmail.trim();
      if (newEmail !== "" && emailValidation(newEmail)) {
        checkIndividualEmail(newEmail);
        setCurrentEmail("");
      }
    }
  };

  const handleKeyUp = (event) => {
    if (event.key === "Enter" || event.key === ".") {
      event.preventDefault();
    }
  };

  const handleChange = (event) => {
    setCurrentEmail(event.target.value);
  };

  const handleRemoveEmail = (index) => {
    const newList = [...emailList];
    newList.splice(index, 1);
    setEmailList(newList);
  };

  const emailBlocks = emailList.map((email, index) => (
    <div key={index} className="email-block">
      <span className="email">{email}</span>
      <button
        type="button"
        className="remove"
        onClick={() => handleRemoveEmail(index)}
      >
        &times;
      </button>
    </div>
  ));

  useEffect(() => {
    if (
      emailList.length &&
      emailBlocksRef.current &&
      emailBlocksContainerRef.current
    ) {
      const newHeight = emailBlocksRef.current.offsetHeight + 0;
      containerHeight < 100 && setContainerHeight(newHeight);
    }
    if (emailList.length === 0) {
      setContainerHeight(0);
      setMarginTop(0);
    }
  }, [emailList]);

  useEffect(() => {
    if (containerHeight > 0)
      setMarginTop(`${emailBlocksRef.current.offsetHeight / 2.5}px`);
  }, [containerHeight]);

  useEffect(() => {
    getUserCount();
  }, []);

  return (
    <div className={`input-text`}>
      <div
        className="email-blocks-container"
        ref={emailBlocksContainerRef}
        style={{ height: containerHeight }}
      >
        <div ref={emailBlocksRef} className="email-blocks">
          {emailBlocks}
        </div>
      </div>
      <div className="input">
        <input
          type="text"
          value={currentEmail}
          onKeyDown={handleKeyDown}
          onKeyUp={handleKeyUp}
          onChange={handleChange}
          placeholder="Enter new user’s email address"
        />
      </div>
      <p className="mt-1">Invitation count: {invitationCount}</p>
      <p className="email-info-message">
        **Please press Enter after each email. Then press Send**
      </p>
    </div>
  );
};

export default EmailInput;
